// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/-/onboarding/feature_library/search(.:format)`
 * - Path helper: `onboarding_feature_library_search_path`
 * - URL helper: `onboarding_feature_library_search_url`
 * - controller#action: `onboarding/feature_library#search`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const onboardingFeatureLibrarySearchPath = /*#__PURE__*/ (...args) => {
  const _organizationOnboardingFeatureLibrarySearchPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"feature_library"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _onboardingFeatureLibrarySearchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"feature_library"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationOnboardingFeatureLibrarySearchPath(organizationPath, ...routeArgs);
  }

  return _onboardingFeatureLibrarySearchPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/onboarding/feature_library/ai_search(.:format)`
 * - Path helper: `onboarding_feature_library_ai_search_path`
 * - URL helper: `onboarding_feature_library_ai_search_url`
 * - controller#action: `onboarding/feature_library#ai_search`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const onboardingFeatureLibraryAiSearchPath = /*#__PURE__*/ (...args) => {
  const _organizationOnboardingFeatureLibraryAiSearchPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"feature_library"],[2,[7,"/"],[2,[6,"ai_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _onboardingFeatureLibraryAiSearchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"feature_library"],[2,[7,"/"],[2,[6,"ai_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationOnboardingFeatureLibraryAiSearchPath(organizationPath, ...routeArgs);
  }

  return _onboardingFeatureLibraryAiSearchPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/onboarding/feature_library/catalog(.:format)`
 * - Path helper: `onboarding_feature_library_catalog_path`
 * - URL helper: `onboarding_feature_library_catalog_url`
 * - controller#action: `onboarding/feature_library#catalog`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const onboardingFeatureLibraryCatalogPath = /*#__PURE__*/ (...args) => {
  const _organizationOnboardingFeatureLibraryCatalogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"feature_library"],[2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _onboardingFeatureLibraryCatalogPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"feature_library"],[2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationOnboardingFeatureLibraryCatalogPath(organizationPath, ...routeArgs);
  }

  return _onboardingFeatureLibraryCatalogPath(...routeArgs);
};

